<template>
  <div id="partners-container">
    <div id="partners-options-container">
      <div id="partners-back">
        <button @click="$router.go(-1)">
          <font-awesome-icon :icon="['fas', 'reply']" />Back
        </button>
      </div>
      <!-- Link to sort in [reverse] alphabetical order -->
      <div id="partners-order">
        <button @click="changeAlphaOrder(alphaOrder)">
          Click here to sort Countries from
          <span v-if="alphaOrder === 'a-z'">Z - A</span>
          <span v-else>A - Z</span>
        </button>
      </div>
    </div>

    <div id="partners-list-container">
      <div id="partners-list-description">
        <!-- <p>If you are interested in learning about the contribution from a specific institution,
        this page might be the best place to start.
        <span v-if="dxaFull !== 'Partners'">The list distinguishes between Partners that have contributed specifically to
        <span class="italic">{{ dxaFull }}</span>,
        and Partners that are represented by {{ dxaMaterial }}-related material contributed to other MWNF projects.
        For this reason, some Partners are listed twice or more.</span>
      </p> -->
        <p v-html="$i18n.t('galleryPartners')"></p>
      </div>

      <LoaderComponent v-if="!loaded" />
      <div v-else id="partners-list-wrapper">
        <div
          class="partners-list"
          v-for="(country, countryIndex) in displayPartners"
          :key="country[0].countryName"
        >
          <div class="partners-country">{{ country[0].countryName }}</div>
          <div class="partner-container">
            <div
              class="partner"
              :class="{
                partnerBorder: applyBorder(
                  partnerIndex,
                  displayPartners[countryIndex]
                ),
              }"
              v-for="(partner, partnerIndex) in displayPartners[countryIndex]"
              :key="partner.partnerName + partner.projectId"
            >
              <div class="partner-text-links-container">
                <div class="partner-name">
                  <router-link
                    class="partner-profile"
                    :to="{
                      name: 'partner',
                      params: {
                        database: partner.projectId,
                        country: partner.countryId,
                        id: partner.partnerId,
                        language: partner.languageId,
                      },
                    }"
                  >
                    <p>{{ partner.partnerName }}</p>
                  </router-link>
                </div>
                <div
                  class="partner-project"
                  :class="backgroundColor(partner.projectId, partner.projectSourceIsExhibition)"
                >
                  {{ partner.projectName }}
                  <!-- Spaces inside spans are intentional -->
                  <span class="partner-status" v-if="partner.isPartner === 1">
                    Partner</span
                  >
                  <span class="partner-status" v-else-if="partner.projectSourceIsExhibition">
                    Partner
                  </span>
                  <span class="partner-status" v-else> Affiliate</span>
                </div>
                <div class="partner-links">
                  <router-link
                    class="partner-profile"
                    :to="{
                      name: 'partner',
                      params: {
                        database: partner.projectId,
                        country: partner.countryId,
                        id: partner.partnerId,
                        language: partner.languageId,
                      },
                    }"
                    >Read more</router-link
                  >
                  <div class="partner-link-divider" v-if="partner.hasObjects">
                    |
                  </div>
                  <router-link
                    v-if="partner.hasObjects"
                    class="partner-objects"
                    :to="{
                      name: 'partner-objects',
                      params: {
                        database: partner.projectId,
                        country: partner.countryId,
                        id: partner.partnerId,
                        page: 1,
                      },
                    }"
                    >View objects</router-link
                  >
                </div>
              </div>
              <div class="partner-logo">
                <img :src="partner.logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { loadLocaleMessages } from "../i18n.js";
import LoaderComponent from "./LoaderComponent.vue";
export default {
  name: "PartnersPage",
  components: {
    LoaderComponent: LoaderComponent,
  },
  data() {
    return {
      dxaFull: process.env.VUE_APP_DXA_FULL,
      dxaMaterial: process.env.VUE_APP_DXA_MATERIAL,
      loaded: false,
      partners: [],
      alphaOrder: "a-z",
      // Partners, A - Z
      sortedPartners: [],
      // Partners, Z - A
      reversedPartners: [],
      // Currently displaying Partners
      displayPartners: [],
      urls: {
        portal: process.env.VUE_APP_PORTAL_URL,
        baroqueArt: process.env.VUE_APP_BAROQUE_ART_URL,
        islamicArt: process.env.VUE_APP_ISLAMIC_ART_URL,
        sharingHistory: process.env.VUE_APP_SHARING_HISTORY_URL,
        galleries: process.env.VUE_APP_GALLERIES_URL,
        images: process.env.VUE_APP_IMAGES_URL,
      },
      emails: {
        contactUs: process.env.VUE_APP_CONTACT_US_EMAIL,
      },
    };
  },
  methods: {
    getPartners: function () {
      if (!this.$global.partners) {
        return axios({
          method: "GET",
          url: `${process.env.VUE_APP_DXA_ENDPOINT}/partners?hash=${process.env.VUE_APP_API_HASH}`,
        }).then(
          (result) => {
            this.$global.partners = result.data;
            this.partners = result.data;
            this.setPartnerArrays();
            this.displayPartners = this.sortedPartners;
            this.loaded = true;
          },
          (error) => {
            this.$router.replace({ name: "error" });
            console.error(error);
          }
        );
      } else {
        this.partners = this.$global.partners;
        this.setPartnerArrays();
        this.displayPartners = this.sortedPartners;
        this.loaded = true;
      }
    },
    // Sort Partners and save to data
    setPartnerArrays: function () {
      let data = this.partners;
      let countries = {};
      for (let i = 0; i < data.length; i++) {
        let country = data[i].countryName;
        if (country in countries) {
          countries[country].push(data[i]);
        } else {
          countries[country] = [data[i]];
        }
      }
      let array = this.arrayFromObject(countries);
      for (let j = 0; j < array.length; j++) {
        array[j].sort(function (a, b) {
          let partnerA = a.partnerName.toUpperCase();
          let partnerB = b.partnerName.toUpperCase();
          if (partnerA < partnerB) {
            return -1;
          }
          if (partnerA > partnerB) {
            return 1;
          }
          let projectA = a.projectName.toUpperCase();
          let projectB = b.projectName.toUpperCase();
          if (partnerA === partnerB) {
            return projectA < projectB ? -1 : 1;
          }
        });
      }

      this.sortedPartners = array;
      this.reversedPartners = array.slice().reverse();
    },
    arrayFromObject: function (object) {
      let array = [];
      for (let i in object) {
        array.push(object[i]);
      }
      return array;
    },
    // Toggle alphabetical order and displaying Partner array
    changeAlphaOrder: function (order) {
      if (order === "a-z") {
        this.alphaOrder = "z-a";
        this.displayPartners = this.reversedPartners;
      } else if (order === "z-a") {
        this.alphaOrder = "a-z";
        this.displayPartners = this.sortedPartners;
      }
    },
    backgroundColor: function (project, isExhibition) {
      return {
        DGA: project === "DGA",
        ISLandEPM: project === "ISL" || project === "EPM",
        AWE: project === "AWE",
        DBA: project === "BAR",
        Galleries: project === "GALLERIES",
        DCA: project === "DCA",
        EXH: isExhibition,
      };
    },
    // Add a separating horizontal line between Partners
    // Used for applying conditional class
    applyBorder: function (index, array) {
      if (index === array.length - 1) {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    this.getPartners();
  },
  mounted() {
    loadLocaleMessages("en");
  }
};
</script>



<style scoped lang="scss">
#partners-container {
  width: 100%;
  background-color: white;
  padding: 0 50px;
}

#partners-options-container {
  @include flex-center;
  justify-content: space-between;
  width: 100%;
}
#partners-back,
#partners-order {
  @include flex-center;
  justify-content: flex-start;
  height: 50px;
  padding-top: 30px;
}
#partners-back .fas {
  font-size: 75%;
  padding-right: 4px;
}
#partners-back button,
#partners-order button {
  @include button-styles;
  padding: 2px;
  font-weight: bold;
}

#partners-list-container {
  @include flex-center;
  flex-direction: column;
  width: 100%;
}

#partners-list-description {
  width: 50%;
  padding-top: 30px;
}
.italic {
  font-style: italic;
}

.loader-container {
  min-height: 400px;
}

#partners-list-wrapper {
  width: 50%;
  padding: 30px 0 50px 0;
}
.partners-list {
  width: 100%;
  margin-bottom: 30px;
}
.partners-country {
  @include country-background-color;
  font-size: 160%;
  font-weight: bold;
  padding: 5px 10px;
}
.partner-container {
  @include flex-center;
  flex-direction: column;
}
.partner {
  width: 100%;
  @include flex-center;
  padding: 30px 10px;
}
.partnerBorder {
  border-bottom: 1px solid $shadow-grey;
}
.partner a {
  text-decoration: none;
  color: black;
  cursor: pointer;
}
.partner-text-links-container {
  @include flex-center;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: 100px;
  width: 100%;
}
.partner-name {
  @include flex-center;
  justify-content: flex-start;
  width: 100%;
}
.partner-name:hover {
  @include link-hover-styles;
}
.partner-name p {
  font-size: 120%;
  font-weight: bold;
}
.partner-project {
  font-size: 90%;
  font-weight: bold;
  font-style: italic;
  border-radius: 10px;
  padding: 0 10px;
}
.partner-status {
  font-style: normal;
}
.DGA {
  background-color: $dga-blue;
  color: $light-text;
}
.ISLandEPM {
  background-color: $dia-yellow;
  color: black;
}
.AWE {
  background-color: $sh-red;
  color: $light-text;
}
.DBA {
  background-color: $dba-blue;
  color: $light-text;
}
.Galleries {
  background-color: $g-grey;
  color: $light-text;
}
.DCA {
  background-color: $dca-tan;
  color: $light-text;
}
.EXH {
  background-color: $exhibitions-color;
  color: white;
}
.partner-links {
  @include flex-center;
}
.partner-link-divider {
  padding: 0 8px;
}
.partner-logo {
  height: 100px;
  min-width: 100px;
  max-width: 150px;
}
.partner-logo img {
  @include image-scale;
  object-fit: contain;
}

/* IE-only */
@media only screen and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .partner-logo {
    position: relative;
    height: 100px;
    width: 400px;
  }
  .partner-logo img {
    max-height: 100%;
    max-width: 100%;
    height: auto;
    width: auto;
    position: absolute;
    right: 0;
    bottom: 0;
    margin: auto;
  }
}

@media only screen and (max-width: 1199px) {
  #partners-list-description {
    width: 70%;
  }
  #partners-list-wrapper {
    width: 70%;
  }
  .partners-country {
    font-size: 150%;
  }
  .partner-name p {
    font-size: 110%;
  }
}

@media only screen and (max-width: 974px) {
  #partners-list-description {
    width: 80%;
  }
  #partners-list-wrapper {
    width: 80%;
  }
  .partners-list {
    margin-bottom: 15px;
  }
}

@media only screen and (max-width: 849px) {
  #partners-list-description {
    width: 88%;
  }
  #partners-list-wrapper {
    width: 88%;
  }
  .partners-country {
    font-size: 130%;
  }
  .partner-name p {
    font-size: 105%;
  }
}

@media only screen and (max-width: 724px) {
  #partners-list-description {
    width: 100%;
  }
  #partners-list-wrapper {
    width: 100%;
  }
  .partners-country {
    font-size: 120%;
  }
  .partner-name p {
    font-size: 100%;
  }
}

@media only screen and (max-width: 599px) {
  #partners-container {
    padding: 0 30px;
  }
  #partners-list-wrapper {
    padding-bottom: 30px;
  }
}

@media only screen and (max-width: 499px) {
  .partner {
    padding: 18px 10px;
  }
  .partner-text-links-container {
    height: 125px;
  }
  .partner-project {
    border-radius: 0;
    padding: 5px;
  }
  .partner-logo {
    height: 125px;
    max-width: 100px;
    margin-left: 5px;
  }
}

/* IE-only */
@media only screen and (-ms-high-contrast: none) and (max-width: 499px),
  (-ms-high-contrast: active) and (max-width: 499px) {
  .partner-logo {
    height: 125px;
    width: 80px;
  }
}

@media only screen and (max-width: 399px) {
  #partners-options-container {
    flex-direction: column;
    align-items: flex-start;
  }
  #partners-order {
    height: auto;
    padding-top: 20px;
  }
  #partners-order button {
    text-align: left;
  }
  #partners-list-description {
    padding-top: 20px;
  }
  .partner {
    flex-direction: column-reverse;
    width: 100%;
  }
  .partner-text-links-container {
    margin-top: 10px;
    height: auto;
  }
  .partner-text-links-container > div {
    margin-bottom: 8px;
  }
  .partner-logo {
    height: 90px;
    width: 100%;
    max-width: 100%;
    margin-left: 0;
    border: 1px solid $background-color;
  }
}

/* IE-only */
@media only screen and (-ms-high-contrast: none) and (max-width: 399px),
  (-ms-high-contrast: active) and (max-width: 399px) {
  .partner-logo {
    height: 90px;
    border: 1px solid $background-color;
  }
  .partner-logo img {
    top: 0;
    left: 0;
  }
}
</style>